import React, { useState } from 'react';
import {
  Tab,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../../../store/slices/users';
import { useNavigate } from 'react-router-dom';
import { NavTabs, VerticalNavTabs, TabsStyled } from './styles';
import { RootState } from 'store';

export default function MainMenu({ vertical = false }: { vertical?: boolean }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false); // State to control the dialog

  const pathname = location.pathname.split('/')[1] || false;

  // Get the user from the Redux store
  const user = useSelector((state: RootState) => state.user.user);

  const handleLogout = () => {
    dispatch(clearUser());
    navigate(ROUTE_PATHS.LOGIN);
  };

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const WrapperTabs = ({
    vertical = false,
    children,
  }: {
    vertical?: boolean;
    children: React.ReactNode;
  }) =>
    vertical ? (
      <VerticalNavTabs container>{children}</VerticalNavTabs>
    ) : (
      <NavTabs container>{children}</NavTabs>
    );

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div style={{ flex: 1 }}>
          <WrapperTabs vertical={vertical}>
            <TabsStyled
              value={pathname}
              textColor={vertical ? 'primary' : 'secondary'}
              orientation={vertical ? 'vertical' : 'horizontal'}
            >
              {/* Always show Campaign Performance Dashboard */}
              <Tab
                label='Campaign Performance Dashboard'
                value=''
                component={NavLink as any}
                to={ROUTE_PATHS.DEFAULT}
              />
              {/* Conditionally render Admin Dashboard tab if the user is an admin */}
              {user?.role?.name.toLowerCase() === 'admin' && (
                <>
                  <Tab
                    label='Admin Dashboard'
                    value='admin'
                    component={NavLink as any}
                    to={ROUTE_PATHS.ADMIN_DASHBOARD}
                  />
                  <Tab
                    label='Control Panel'
                    value='admin'
                    component={NavLink as any}
                    to={ROUTE_PATHS.CONTROL_PANEL}
                  />
                </>
              )}
            </TabsStyled>
          </WrapperTabs>
        </div>
        <div>
          <Button
            variant='outlined'
            onClick={handleOpenDialog}
            style={{
              color: 'rgba(58, 111, 248, 1)',
            }}
          >
            Logout
          </Button>
        </div>
      </div>

      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>{'Logout Confirmation'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color='primary'>
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            style={{ color: 'rgba(58, 111, 248, 1)' }}
            autoFocus
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
